import { render, staticRenderFns } from "./StrapiFaqView.vue?vue&type=template&id=5f0e8bb0"
import script from "./StrapiFaqView.vue?vue&type=script&lang=js"
export * from "./StrapiFaqView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports